/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2024 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { HTMLAttributes, useEffect, useState } from 'preact/compat';
import { classes, Container } from '@adobe-commerce/elsie/lib';
import { events } from '@adobe-commerce/event-bus';
import { ProductModel } from '@/pdp/data/models';
import { getFetchedProductData } from '@/pdp/api';

export interface ProductShortDescriptionProps
  extends HTMLAttributes<HTMLDivElement> {
  scope?: string;
}

export const ProductShortDescription: Container<
  ProductShortDescriptionProps,
  ProductModel | null
> = ({ initialData = null, scope, children, ...props }) => {
  const [data, setData] = useState<ProductModel | null>(initialData);

  useEffect(() => {
    const dataEvent = events.on('pdp/data', setData, { scope });

    return () => {
      dataEvent?.off();
    };
  }, [scope]);

  if (!data) return null;

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: data?.shortDescription ?? '' }}
      {...props}
      className={classes(['pdp-short-description', props.className])}
    />
  );
};

ProductShortDescription.getInitialData = getFetchedProductData;
